define('views/list',["require", "exports", "backbone", "loader"], function (_require, _exports, _backbone, _loader) {
  "use strict";

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  var cache;
  function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var r, c, a = Object.defineProperty, n = { __proto__: null, default: e }; if (Object(e) !== e) return n; if (cache || "function" != typeof WeakMap || (cache = new WeakMap()), cache) { if (cache.has(e)) return cache.get(e); cache.set(e, n); } for (c in e) "default" !== c && {}.hasOwnProperty.call(e, c) && ((r = a && Object.getOwnPropertyDescriptor(e, c)) && (r.get || r.set) ? a(n, c, r) : n[c] = e[c]); return n; }
  function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
  function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
  function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
  function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
  function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a, u = !0; return { s: function s() { t = t.call(r); }, n: function n() { u = !0; var r = t.next(); return r.done ? { done: !0 } : { value: r.value, done: u = !1 }; }, e: function e(r) { o = !0, a = r; }, f: function f() { try { u || null == t.return || t.return(); } finally { if (o) throw a; } } }; }
  function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
  function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
  var RENT = Symbol();
  var _default = _exports.default = _backbone.View.extend({
    events: {
      'click .rental-list-empty .rental-list-empty__text a'() {
        this.listState.resetFilter();
      }
    },
    initialize() {
      this.list = this.el.querySelector('.rental-list');
      this.listEmpty = this.el.querySelector('.rental-list-empty');
      this.loaderEl = this.el.querySelector('.loader');
      this.header = this.el.querySelector('.rental-list-header');
      this.end = this.el.querySelector('#rental-list-end');
      GA.header.preserve(false);
      var standalone = navigator.standalone || window.matchMedia && matchMedia('(display-mode: standalone)').matches;
      var desktop = document.documentElement.classList.contains('no-touchevents');
      this.itemOpenInNewTab = desktop && !standalone;
      this._updateItems();
    },
    _initState(State, FilterHeader, FilterModal) {
      var _listState$get;
      var listState = this.listState = new State({}, {
        prefix: location.pathname
      });
      this.filter = new FilterHeader({
        el: GA.header.filter,
        listState
      });
      this.listenTo(this.filter, 'reset-filter', () => {
        listState.resetFilter();
      });
      this.listenTo(this.filter, 'toggle-map', () => {
        this._toggleMap();
      });
      this.listenTo(this.filter, 'show-modal', () => {
        if (!this.filterModal) {
          this.filterModal = new FilterModal({
            el: this.el.nextElementSibling,
            listState
          });
        }
        this.filterModal.show();
      });
      listState.parseQuery();
      this.listenTo(listState, 'state-change', this.listNew);
      this.listenTo(listState, 'change:p', this.updateHistory);
      this.pages = Number((_listState$get = listState.get('p')) !== null && _listState$get !== void 0 ? _listState$get : 1);
    },
    destroy() {
      this.stopListening();
      this.undelegateEvents();
      this.filter.destroy();
      if (this.filterModal) {
        this.filterModal.destroy();
      }
    },
    async loader(task, spinner) {
      (0, _loader.startLoader)();
      if (spinner) {
        this.loaderEl.hidden = false;
      }
      try {
        return await task();
      } finally {
        if (spinner) {
          this.loaderEl.hidden = true;
        }
        (0, _loader.stopLoader)();
      }
    },
    shown() {
      addEventListener('scroll', this._windowScroll = this.scroll.bind(this));
      (async () => {
        while (this.list.dataset.end !== '1' && isElementVisible(this.end)) {
          await this.listMore();
        }
      })();
    },
    hidden() {
      removeEventListener('scroll', this._windowScroll);
    },
    scroll() {
      var _this$pages;
      if ((0, _loader.loaderDisabled)() || (0, _loader.isLoading)()) {
        return;
      }
      var dh = document.body.scrollHeight;
      var lh = this.list.scrollHeight;
      var pages = (_this$pages = this.pages) !== null && _this$pages !== void 0 ? _this$pages : 0;
      var page;
      if (scrollY + innerHeight > dh - 500) {
        page = pages + 1;
      } else {
        page = Math.round((innerHeight / 2 + scrollY - (dh - lh)) * pages / lh) + 1;
      }
      this.listState.set({
        p: page,
        pf: page > 1
      });
      if (page > pages) {
        this.listMore();
      }
    },
    updateHistory() {
      var _this$listState$getLo = this.listState.getLocation(),
        path = _this$listState$getLo.path,
        params = _this$listState$getLo.params;
      var search = String(params);
      sessionStorage.setItem(path, search);
      history.replaceState({}, '', `${path}${search ? `?${search}` : ''}`);
    },
    currency(currency) {
      this.listState.set({
        currency
      });
    },
    async listMore() {
      var _params$get;
      if (this.list.dataset.end === '1') {
        return;
      }
      if (this.listState.get('p') < this.pages) {
        return;
      }
      if ((0, _loader.loaderDisabled)() || (0, _loader.isLoading)()) {
        return;
      }
      var _this$listState$getLo2 = this.listState.getLocation(),
        path = _this$listState$getLo2.path,
        params = _this$listState$getLo2.params;
      params.delete('pf');
      var data = await this.loader(() => getJson(`${path}?${params}`), true);
      this.list.dataset.end = data.end ? '1' : '';
      this.list.insertAdjacentHTML('beforeend', data.rentals);
      this.pages = Number((_params$get = params.get('p')) !== null && _params$get !== void 0 ? _params$get : 1);
      this._updateItems();
    },
    async listNew() {
      if ((0, _loader.loaderDisabled)() || (0, _loader.isLoading)()) {
        return;
      }
      this.list.dataset.end = '';
      this.listState.set({
        p: 1,
        pf: false
      });
      this.updateHistory();
      var _this$listState$getLo3 = this.listState.getLocation(),
        path = _this$listState$getLo3.path,
        params = _this$listState$getLo3.params;
      var query = new URLSearchParams(params.toString());
      if (this._mapView) {
        query.set('map', '');
        var data = await this.loader(() => getJson(`${path}?${query}`));
        this._updateMap(data);
      } else {
        var _query$get;
        var _data = await this.loader(() => getJson(`${path}?${query}`));
        this.list.textContent = '';
        this.list.dataset.end = _data.end ? '1' : '';
        this.list.insertAdjacentHTML('beforeend', _data.rentals);
        this.pages = Number((_query$get = query.get('p')) !== null && _query$get !== void 0 ? _query$get : 1);
        this.listEmpty.hidden = !_data.empty;
        this.list.hidden = _data.empty;
        if (_data.title) {
          document.title = _data.title;
        }
        if (_data.header) {
          this.header.querySelector('.rental-list-header__title').textContent = _data.header;
        }
        if (_data.tagline) {
          this.header.querySelector('.rental-list-header__tagline').innerHTML = _data.tagline;
        }
        if (_data.breadcrumb) {
          GA.header.searchLabel.querySelector('span').textContent = _data.breadcrumb;
        }
        if (_data.breadcrumbs) {
          var breadcrumbs = this.header.querySelector('.b-breadcrumbs');
          if (breadcrumbs) {
            while (breadcrumbs.firstElementChild) {
              breadcrumbs.firstElementChild.remove();
            }
            var _iterator = _createForOfIteratorHelper(_data.breadcrumbs),
              _step;
            try {
              for (_iterator.s(); !(_step = _iterator.n()).done;) {
                var b = _step.value;
                var link = document.createElement('a');
                link.classList.add('b-breadcrumbs__link');
                link.textContent = b.title;
                link.href = b.url;
                var item = document.createElement('span');
                item.classList.add('b-breadcrumbs__item');
                item.append(link);
                breadcrumbs.append(item);
              }
            } catch (err) {
              _iterator.e(err);
            } finally {
              _iterator.f();
            }
          }
        }
        this._updateItems();
        scrollTo(0, 0);
      }
    },
    _updateItems() {
      if (this.itemOpenInNewTab) {
        var _iterator2 = _createForOfIteratorHelper(this.list.querySelectorAll('.rental-list__item')),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var item = _step2.value;
            var _iterator3 = _createForOfIteratorHelper(item.querySelectorAll('a')),
              _step3;
            try {
              for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
                var a = _step3.value;
                a.target = '_blank';
              }
            } catch (err) {
              _iterator3.e(err);
            } finally {
              _iterator3.f();
            }
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      }
    },
    async _toggleMap() {
      var mapEl = this.el.parentNode.querySelector('.b-rental-map');
      if (this._mapView) {
        mapEl.hidden = true;
        this.el.hidden = false;
        scrollTo(0, Number(this.el.dataset.scrollY));
        this._mapView = false;
        this.listNew();
      } else {
        this._mapView = true;
        var _await$Promise$all = await Promise.all([new Promise((_resolve, _reject) => _require(['@googlemaps/js-api-loader'], imported => _resolve(_interopRequireWildcard(imported)), _reject)), new Promise((_resolve, _reject) => _require(['@google/markerclustererplus'], imported => _resolve(_interopRequireWildcard(imported)), _reject))]),
          _await$Promise$all2 = _slicedToArray(_await$Promise$all, 2),
          _await$Promise$all2$ = _await$Promise$all2[0],
          setOptions = _await$Promise$all2$.setOptions,
          importLibrary = _await$Promise$all2$.importLibrary,
          MarkerClusterer = _await$Promise$all2[1].default;
        setOptions({
          key: mapEl.dataset.googleMapsKey,
          v: 'weekly',
          libraries: ['places'],
          language: document.documentElement.lang,
          region: 'FR'
        });
        await importLibrary('maps');
        this.MarkerClusterer = MarkerClusterer;
        this._initMap(mapEl);
        mapEl.hidden = false;
        this.el.dataset.scrollY = scrollY;
        this.el.hidden = true;
        this.listNew();
      }
      this.filter.toggleMap(this._mapView);
    },
    async _clickMap(marker) {
      if (this._mapInfobox) {
        this._mapInfobox.close();
      }
      var data = await getJson(`${location.pathname}?num=${marker[RENT]}`);
      var div = document.createElement('div');
      div.insertAdjacentHTML('beforeend', data.rentals);
      var content = div.querySelector('.rental-list__card');
      content.classList.add('rental-list__item');
      content.style.width = '300px';
      this._mapInfobox = new google.maps.InfoWindow({
        content
      });
      this._mapInfobox.open(this._map, marker);
    },
    _initMap(mapEl) {
      if (this._mapInitialized) {
        return;
      }
      this._map = new google.maps.Map(mapEl.querySelector('.b-rental-map__frame'), {
        zoom: 13,
        center: {
          lat: 48.8588589,
          lng: 2.3470599
        },
        styles: [{
          featureType: 'road',
          elementType: 'labels.icon',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'road',
          elementType: 'geometry.stroke',
          stylers: [{
            lightness: 24
          }]
        }, {
          featureType: 'road.highway',
          elementType: 'geometry.fill',
          stylers: [{
            lightness: 75
          }]
        }, {
          featureType: 'road.highway',
          elementType: 'geometry.stroke',
          stylers: [{
            lightness: 24
          }]
        }, {
          featureType: 'water',
          elementType: 'geometry.fill',
          stylers: [{
            color: '#8cc8de'
          }]
        }, {
          featureType: 'landscape.natural',
          elementType: 'geometry.fill',
          stylers: [{
            color: '#cfe1d0'
          }]
        }, {
          featureType: 'poi',
          elementType: 'geometry.fill',
          stylers: [{
            color: '#cfe1d0'
          }]
        }, {
          featureType: 'poi.school',
          elementType: 'geometry.fill',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'poi.medical',
          elementType: 'geometry.fill',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'poi.government',
          elementType: 'geometry.fill',
          stylers: [{
            visibility: 'off'
          }]
        }, {
          featureType: 'poi.sports_complex',
          elementType: 'geometry.fill',
          stylers: [{
            color: '#dae8db'
          }]
        }]
      });
      this._map.addListener('click', () => {
        if (this._mapInfobox) {
          this._mapInfobox.close();
        }
      });
      this._map.addListener('bounds_changed', () => {
        if (this._mapIgnoreUpdating > 0) {
          this._mapIgnoreUpdating--;
          return;
        }
        var bounds = this._map.getBounds();
        this.listState.set({
          neighborhood: null,
          bounds: {
            west: bounds.getSouthWest().lng(),
            south: bounds.getSouthWest().lat(),
            east: bounds.getNorthEast().lng(),
            north: bounds.getNorthEast().lat()
          }
        });
      });
      this._mapCluster = new this.MarkerClusterer(this._map, [], {
        minimumClusterSize: 5,
        maxZoom: 18,
        imagePath: '/node_modules/@google/markerclustererplus/images/m'
      });
      this._mapInitialized = true;
    },
    _updateMap(data) {
      var bounds = new google.maps.LatLngBounds();
      var markers = new Map();
      var _iterator4 = _createForOfIteratorHelper(this._mapCluster.getMarkers()),
        _step4;
      try {
        for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
          var marker = _step4.value;
          markers.set(marker[RENT], marker);
        }
      } catch (err) {
        _iterator4.e(err);
      } finally {
        _iterator4.f();
      }
      var newMarkers = [];
      var _iterator5 = _createForOfIteratorHelper(data),
        _step5;
      try {
        for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
          var item = _step5.value;
          var pos = new google.maps.LatLng(item.lat, item.lng);
          bounds.extend(pos);
          if (!markers.has(item.num)) {
            var _marker = new google.maps.Marker({
              position: pos,
              title: item.title
            });
            _marker[RENT] = item.num;
            _marker.addListener('click', this._clickMap.bind(this, _marker));
            newMarkers.push(_marker);
          }
          markers.delete(item.num);
        }
      } catch (err) {
        _iterator5.e(err);
      } finally {
        _iterator5.f();
      }
      var oldMarkers = markers.values().toArray();
      if (newMarkers.length > 0 || oldMarkers.length > 0) {
        this._mapCluster.addMarkers(newMarkers, true);
        this._mapCluster.removeMarkers(oldMarkers, true);
        this._mapCluster.repaint();
        if (!this.listState.get('bounds')) {
          this._mapIgnoreUpdating = 1;
          this._map.fitBounds(bounds);
        }
      }
    }
  });
  async function getJson(url) {
    var res = await fetch(url, {
      credentials: 'include',
      headers: {
        'accept': 'application/json'
      }
    });
    return await res.json();
  }
  function isElementVisible(element) {
    var scrollTop = scrollY;
    var windowHeight = innerHeight;
    var elTop = element.offsetTop;
    var elHeight = element.offsetHeight;
    return elTop - scrollTop < windowHeight && elTop + elHeight > scrollTop;
  }
});//# sourceMappingURL=list.js.map
;
